import { useEffect, useState } from "react";
import { getSchools, getContractYears } from "../../services/apis/StudioApi";
import SchoolSelector from "../../components/Selector/SchoolSelector";
import Selector from "../../components/Selector/Selector";
import { schoolNameState } from "../../stores/schoolAtoms"
import { useSetRecoilState } from "recoil"
import { useNavigate } from 'react-router-dom'
import Title from "../../components/Title/Title";

const SelectSchoolPage = () => {
    const [schools, setSchools] = useState([]);
    const [years, setYears] = useState([]);
    const [selectedYear, setSelectedYear] = useState(null)
    const setSchoolName = useSetRecoilState(schoolNameState)
    const navigate = useNavigate()
    const [selected, setSelected] = useState(null)
    const onSchoolSelect = (value) => {
        setSelected(value)
        setSchoolName(value.name)
        navigate(`/school/${value.id}/`)
    }

    const onYearSelect = (year) => {
        setSelectedYear(year)
    }

    const fetchSchools = (year) => {
        getSchools(year).then(res => {
            if (res.status === 200) {
                setSchools(res.data)
            } else if (res.status === 401) {
                navigate("/studio/login")
            }
        })
    }

    useEffect(() => {
        if (selectedYear) {
            fetchSchools(selectedYear)
        }
    }, [selectedYear])

    useEffect(() => {
        getContractYears().then(res => {
            if (res.status === 200) {
                const fetchedYears = res.data.contract_years
                setYears(fetchedYears)
                if (fetchedYears.length > 0) {
                    setSelectedYear(Math.max(...fetchedYears))
                }
            }
        })
        setSchoolName("")
    }, [])

    return (
        <div className="">
            <div className="flex flex-row justify-between items-end mb-2">
                <Title label="학교 선택" />
                {
                    (years.length > 0) &&
                    <Selector
                        label={selectedYear + '년'}
                        items={years}
                        handleChange={onYearSelect}
                        itemLabel={(item) => item + '년'}
                        fit={true}
                    />
                }
            </div>
            <SchoolSelector schools={schools} onSchoolSelect={onSchoolSelect} />
        </div>
    )
}

export default SelectSchoolPage;